import { Component, ViewChild, OnInit, Output, ViewChildren, QueryList,HostListener,EventEmitter,ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Global } from '../../../shared/global';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
import {
  Lists_phongban, Lists_ngachluong, Lists_nguonkinhphi, Lists_loaikhoan, Lists_tieumuc, Lists_loaitaisan
} from '../../../routes/menu'
import 'jquery'
import 'bootstrap'


const swal = require('sweetalert');
@Component({
    selector: 'app-dm-chuyentieptaisanedit',
  templateUrl: './chuyentieptaisanedit.component.html',
    //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./chuyentieptaisanedit.component.scss'],
    providers: [ListService, Repository]
})


export class chuyentieptaisaneditComponent implements OnInit {
  inputloaitaisans: any;
  doituongSelect: any = {Id: null, ChiTiets:[]};
    quyen_them: boolean = false;
    quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  tabselected: number = 1;
    public ngaycap: Date = null;
  inputphongbans: any
  inputngachluongs: any;
  inputloaicanbos: any = [{ Id: 1, Name: 'Biên chế' }, { Id: 2, Name: 'Hợp đồng' }, { Id: 3, Name: 'Tập sự' }]
  inputnguonkinhphis: any;
  inputloaikhoans: any;
  inputtieumucs: any;
  inputkhoanluongthus: any;
  inputkhoanluongtrus: any;
  indLoading: boolean = false;
  
        nhomdtid:string=null;

    @ViewChild('slCapTren',{static:false}) slCapTren: NgSelectComponent;
  @Output() save: EventEmitter<any> = new EventEmitter();
  @ViewChildren("myinput") divs: QueryList<ElementRef>;
  @ViewChildren(NgSelectComponent) slcombo: QueryList<NgSelectComponent>

  public ngxCurrencyOptions = {
    prefix: '',
    thousands: '.',
    decimal: ',',
    precision: 0,
    allowNegative: true
  };

  public ngxSLOptions = {
    prefix: '',
    thousands: '.',
    decimal: ',',
    precision: 4,
    allowNegative: true
  };
   

    constructor( private _dataService: ListService, private repo: Repository) {
       
        
    }
  donviid: any;


  ngOnInit(): void {
    var authlogin = localStorage.getItem('currentUser');
    if (authlogin) {

      let data = JSON.parse(authlogin);
      this.donviid = data.id_don_vi;
    
    }

   


   
  }
  
    

    // @HostListener('document:keydown', ['$event'])
    // public handleKeyboardEvent(event: KeyboardEvent): void {
      
    //   if(event.key==="F9")
    //   {
    //       this.saveproduct();
    //   }
    //   event.stopPropagation();
     
    // }

    comboSearchFn(term: string, item: any) {
        term = term.toLowerCase();
        return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
    }
    @ViewChild("mafocus",{static:false}) mafocus : ElementRef;
  callForm: any;
  
  loadDataInit(nhomdoituongid: string, id: string, donviid: string) {
    let data;
      var authlogin = localStorage.getItem('currentUser');
      if (authlogin) {

        data= JSON.parse(authlogin);
       
      }    
    this.repo.getRequest("api/doituong/getloaitaisan02/" + Lists_loaitaisan.id + '/null/' + donviid)
      .subscribe(response => {
        this.inputloaitaisans = response;
      });

    $('#loading').show();
    this.repo.postRequest("api/doituongtaisan/getds_taisanchuyentiep", { NamKeToan: data.nam_ke_toan, DonViId: donviid, UserName: data.user_name })
      .subscribe(response => {
        $('#loading').hide();
        if (response.ThongBao == null) {
          this.doituongSelect.ChiTiets = response.ChiTiets;
          (window as any).timer01(3, 1500, 'fixTablechungtukhac_01');
        }
        else {
          swal('Lỗi!', response.ThongBao, 'error');
        }
      }); 
       
             
  }
  onTaiSanChange($event, hang: number) {
    var rs = this.doituongSelect.ChiTiets[hang];
    if (typeof $event === "undefined") {
      rs.Loai_Tai_San_Id = null;
    }
    else {
      rs.Thoi_Gian_Khau_Hao = $event.Thoi_Gian_Khau_Hao;
    }
  }

    keyTenPress(event: any) { 
        if (event.which === 13) {
            this.slCapTren.focus();
            event.preventDefault();
          }
   }
    public closeModal(){
        this.save.emit(null);
    }
    public saveproduct() {
       

      $('#loading').show();
      this.repo.postRequest("api/doituongtaisan/addorupdate_taisanchuyentiep", this.doituongSelect)
            .subscribe(response => {  
              console.log(response);
              $('#loading').hide();
              if (response.ThongBao == null) {
                this.save.emit(null);
              }
              else {
                swal('Lỗi!', response.ThongBao, 'error');
              }
            }); 
    }
  maxcot: number = 6;

 
  //----------event xử lý di chuyển Enter--------------------------------------
  setComboFocus(hang: number, cot: number, luoi: number) {
    var tencombo: string = hang + '_' + cot + '_' + luoi;
    var ketqua = false;

    this.slcombo.forEach(
      (question) => {
        if (question.labelForId === tencombo) {

          ketqua = true;
          question.focus();
        }
      }
    );

    if (ketqua === false) {
      this.divs.forEach(
        (div) => {

          if (div.nativeElement.id === tencombo) {
            ketqua = true;
            div.nativeElement.focus();
          }

        }
      );
    }
  }
  
 
   


}
